import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ResetPwdCard } from '../../components';
import { LoginNotiOneStyle, LoginNotiTwoStyle, loginUserBg, logown, LoginNotiThirdStyle, LoginNotiFourStyle } from '../../img';
import { userReset } from '../../ducks/auth';
import SimpleCrypto from 'simple-crypto-js';
// import { toast } from 'react-toastify';
import toast from '../../components/Toastify';
import SimpleReactValidator from 'simple-react-validator';

const _secretKey = process.env.REACT_APP_SECRET_KEY_FOR_CRYPTO;
const simpleCrypto = new SimpleCrypto(_secretKey);
let _u = '';

class ResetPwd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rpt: '',
      pd: '',
      npd: ''
    };
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    localStorage.removeItem('isOpen');
    let params = new URLSearchParams(window.location.search);
    _u = params.get('u');
    this.state.rpt = _u;
    let mainDiv = document.getElementById('main-wrapper');
    mainDiv.className = 'pb-0 mob-log';
  }

  handleStateChange = (state, value) => {
    this.setState({ [state]: value });
  }

  handlerReset = (e) => {
    e.preventDefault();
    let that = this;
    if (!that.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      if (this.state.pd === this.state.npd) {
        let pass = simpleCrypto.encrypt(this.state.pd);
        this.state.pd = pass;
        this.props.userReset(this.state);
      }
      else {
        toast.info('New password and conform password not match');
      }
    }
  }



  render() {
    return (
      <div className="nf_login-area">
        <div className="nf_container-login100">
          <div className="nf_login-left nf_login-box" >
            <div className="login-side-text">
              <h2 className="signup-noti-text">
                When people hear about your brand from real people, they trust your brand and also establishes your brand as a prominent one.
              </h2>
            </div>
            <div className="login-display-noti">
              <img className="notifiavtion-one" src={LoginNotiOneStyle} alt="" id='reset-1' style={{ display: 'none' }} />
              <img src={LoginNotiTwoStyle} alt="" id='reset-2' style={{ display: 'none' }} />
              <img src={LoginNotiThirdStyle} alt="" id='reset-3' style={{ display: 'none' }} />
              <img src={LoginNotiFourStyle} alt="" id="reset-4" style={{ display: 'none' }} />
            </div>
            <div className="loginusercomputer">
              <img src={loginUserBg} alt="" />
            </div>

            <a href='https://wisernotify.com/' className="login-logo">
              <img src={logown} alt="" />
            </a>
          </div>
          <div className="nf_login-right nf_login-box" >
            <div className=" nf_login-part">
              <div className="nf_login-header  mb-50">
                <h1 className="display-1 text-left black-text ">
                  New Password
                </h1>
                <h4 className="text-left font-normal">
                  Don't worry sit back  and fell relax we will take care of this
                </h4>
              </div>
              <div className="nf_login-block">
                <div className="login-title">
                  <h3 className="display-3 text-left">Reset your password</h3>
                </div>
                <ResetPwdCard
                  handlerReset={this.handlerReset}
                  handleStateChange={this.handleStateChange}
                  validator={this.validator}
                  state={this.state}
                  loading={this.props.loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  login: state.reset,
  loading: state.getIn(['loading', 'state']),
});

const mapDispatchToProps = {
  userReset
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ResetPwd);



// WEBPACK FOOTER //
// ./src/containers/ResetPwd/ResetPwd.js